import { decodeToken } from './token';
import { useAppSelector } from '@/app/store/hooks';

export function getUserRole(token: string | null): string | null {
  if (!token) return null;
  const decoded = decodeToken(token);
  return decoded?.role || null;
}

export function isAdmin(role: string | null | undefined): boolean {
  return role === 'admin' || role === 'administrator';
}

export function useIsAdmin(): boolean {
  const user = useAppSelector((state) => state.auth.user);
  const accessToken = useAppSelector((state) => state.auth.tokens.accessToken);
  
  if (user?.role) {
    return isAdmin(user.role);
  }
  
  if (accessToken) {
    const role = getUserRole(accessToken);
    return isAdmin(role);
  }
  
  return false;
}

export function checkIsAdmin(user: { role?: string } | null, accessToken: string | null): boolean {
  if (user?.role) {
    return isAdmin(user.role);
  }
  
  if (accessToken) {
    const role = getUserRole(accessToken);
    return isAdmin(role);
  }
  
  return false;
}
